export const STATUS = {
  NEW: "new",
  APPROVED: "approved",
  REJECTED: "rejected",
  CLOSED: "closed",
};
